﻿import $ from "jquery";
import { GuiBase } from "./GuiBase";
import { GuiFilterSort } from "./GuiFilterSort";
import Collapse from "bootstrap/js/dist/collapse";
export class GuiListGeneric extends GuiBase {

    selectorErzList: string = "div.erz-list";

    constructor(public listName: string) {
        super(listName);

        new GuiFilterSort($(this.selectorErzList), () => this.attachListEvents());

        $("button.erz-list-add").on("click",
            () => {
                this.lock();
                const urladd = $("div.row.erz-list-header").data("urladd") as string | undefined;

                if (urladd != undefined) {
                    document.location.href = urladd;
                    return;
                }

                const url = $("div.row.erz-list-header").data("url") as string;
                document.location.href = url;
            });

        $("#btnListSearch").on("click",
            () => {
                //$("form.search").show();
                if ($("form.search:visible").length === 1) {
                    $("form.search").slideUp();
                } else {
                    $("form.search").slideDown();
                }
            });
    }



    protected attachListEvents() {
        this.log("attachListEvents");
        $("div.erz-list-element > div").not(".col-button").on("click", (e) => { this.clickRow(e); });

        document.querySelectorAll('[data-bs-toggle="collapse"]').forEach(function (el) {
            new Collapse(el, {
                toggle: false  // Prevent it from auto-toggling when initialized
            });
        });

    }

    protected clickRow(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement> ) {
        this.log("clickRow");
        e.preventDefault();

        // Suche in Zeile und dann in header
        const id = $(e.currentTarget).parent().data("id") as string;
        const ret = $(e.currentTarget).data("ret") as string;
        let url = $(this.selectorErzList).data("goto-url") as string;
        if (url == undefined) {
            this.log("no url defined");
            return;
        }
        url = `${url}/${id}`;

        if (ret != undefined) {
            url = url + "?ret=" + ret;
        }

        this.gotoUrl(url);
    }
}
